import React from 'react';
import { Chip } from '@material-ui/core';

//css
import Styles from './styles';
const useStyles = Styles();

export default ({
  opcoesFilial,
  opcoesCondicao,
  colunasFilterTags,
  handlerClearFilterTag
}) => {
  const classes = useStyles();

  const getName = (col) => {
    if (col.key === "Condição") {
      return opcoesCondicao.filter(e => e.id == parseInt(col.value))[0].name;
    }
    if (col.key === "Filial") {
      return opcoesFilial.filter(e => e.id == parseInt(col.value))[0].name;
    }
    return col.value;
  };

  const listaTags = colunasFilterTags.map((col, i) =>
    <span key={i}>
      {col.key && col.value && col.value != "" &&
        <Chip
          label={`${col.key}: ${getName(col)}`}
          onDelete={(e) => { handlerClearFilterTag(i, true) }}
          className={classes.chip}
        />
      }
    </span>
  );

  return (
    <>
      {listaTags}
    </>
  );
};
